import { render } from "./ShowTourButton.vue?vue&type=template&id=a0321856"
import script from "./ShowTourButton.vue?vue&type=script&lang=js"
export * from "./ShowTourButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__